export const featurePath = '/v4/b2b';

export const featureKeys = {
  all: [{ scope: 'b2b-dashboard' }] as const,

  stats: () => [{ ...featureKeys.all[0], entity: 'stats' }] as const,

  opportunities: (column: string, page: number) =>
    [{ ...featureKeys.all[0], entity: 'opportunities', column, page }] as const,

  events: (column: string, page: number) =>
    [{ ...featureKeys.all[0], entity: 'events', column, page }] as const,
};

export type B2bMetric = {
  base: number;
  comparison: number;
  quota?: number; // cents; present on the B2B-team weekly Sales metric only
};

export type B2bPeriodStats = {
  bookings: B2bMetric;
  sales: B2bMetric;
  leads: B2bMetric;
};

export type B2bScopeStats = {
  this_week: B2bPeriodStats;
  this_month: B2bPeriodStats;
};

export type B2bStats = {
  all_nbe: B2bScopeStats;
  b2b_team: B2bScopeStats;
};

// The opportunity/event endpoints serialize Eloquent models directly; these
// list only the fields the dashboard cards render.
export type OpportunityLead = {
  lead_id: number;
  name: string;
  phone: string | null;
  status: string;
  event_type_id: number | null;
  event_type_name?: string | null;
  followup_at: string | null;
  waiting_since: string | null;
  firstcontact_at: string | null;
};

export type OpportunityCustomer = {
  customer_id: number;
  first_name: string | null;
  last_name: string | null;
  organization_name: string | null;
  organization_type: string | null;
  phone: string | null;
  followup_at: string | null;
  last_booked: string | null;
};

export type B2bEvent = {
  event_id: number;
  name: string | null;
  total: number; // dollars -- serialized through the Currency cast, unlike the stats `sales` fields (which are cents, summed from the raw column server-side)
  booked_at: string | null;
  start_at: string | null;
  status: string;
};
